import { language } from "@chef/constants";

const intl = (
  {
    dk: {
      LENGTH_OF_PHONE_NUMBER: 8,
    },
    se: {
      LENGTH_OF_PHONE_NUMBER: 10,
    },
    no: {
      LENGTH_OF_PHONE_NUMBER: 8,
    },
  } as const
)[language];

export const isValidTelephoneNumber = (telephone: string): boolean => {
  if (Number.isNaN(Number(telephone))) {
    return false;
  }
  if (telephone.length === intl.LENGTH_OF_PHONE_NUMBER) {
    return true;
  }
  return false;
};
